import React, { FunctionComponent } from 'react';
import { Duration, Distance } from '../../../../types/__generated__';
import styles from './FitnessTable.scss';
import { FormattedDuration } from '../../Formatters/FormattedDuration';
import { FormattedDistance } from '../../Formatters/FormattedDistance';

type FitnessTableProps = {
  headings: React.ReactNode[];
  rows: (number | Duration | Distance)[][];
  caption?: string;
};

const isDuration = (value?: any): value is Duration =>
  (value as Duration).__typename === 'Duration';

const isDistance = (value: any): value is Distance =>
  (value as Distance).__typename === 'Distance';

const renderCell = (value: number | Duration | Distance): React.ReactNode => {
  if (isDuration(value)) {
    return <FormattedDuration value={value} />;
  }
  if (isDistance(value)) {
    return <FormattedDistance value={value} />;
  }
  return value;
};

export const FitnessTable: FunctionComponent<FitnessTableProps> = ({
  headings,
  rows,
  caption,
}) => {
  const colWidth = 100 / headings.length;
  return (
    <table className={styles.table} aria-label={caption}>
      <thead>
        <tr>
          {headings.map((heading, i) => (
            <th scope="col" key={i} style={{ width: `${colWidth}%` }}>
              {heading}
            </th>
          ))}
        </tr>
      </thead>
      <tbody>
        <tr>
          {rows.map((row, i) =>
            row.map((item, j) => <td key={`${i + j}`}>{renderCell(item)}</td>),
          )}
        </tr>
      </tbody>
    </table>
  );
};
